export default "__VITE_ASSET__DBwjH6DU__"